import script from "./DistributorProductDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DistributorProductDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./DistributorProductDetailModal.vue?vue&type=style&index=0&id=ae3cc162&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae3cc162"]])

export default __exports__